var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-text-content", {
    attrs: { title: _vm.$t("dueAt"), content: _vm.dueAt },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }